/**
 * Cookie consent overlay (GDPR).
 * Закрытие, переключение между main/preferences экранами.
 */

function initCookieModal() {
    const overlay = document.getElementById('cookieOverlay');
    const screenMain = document.getElementById('cookieScreenMain');
    const screenPref = document.getElementById('cookieScreenPreferences');

    if (!overlay) return; // модалка не рендерится (cookie_settings уже в сессии)

    const bindClick = (id, handler) => {
        const el = document.getElementById(id);
        if (el) el.addEventListener('click', handler);
    };

    const closeOverlay = () => { overlay.classList.remove('is-active'); };

    bindClick('cookieCloseBtn', closeOverlay);

    bindClick('managePrefBtn', () => {
        if (screenMain) screenMain.style.display = 'none';
        if (screenPref) screenPref.style.display = '';
    });

    bindClick('cookieBackBtn', () => {
        if (screenPref) screenPref.style.display = 'none';
        if (screenMain) screenMain.style.display = '';
    });

    // TODO: POST-сохранение выбора на бэк (сейчас только закрытие overlay)
    bindClick('acceptAllBtn', closeOverlay);
    bindClick('rejectNonEssentialBtn', closeOverlay);
    bindClick('rejectAllBtn', closeOverlay);
    bindClick('cookieSaveBtn', closeOverlay);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieModal);
} else {
    initCookieModal();
}
